// src/components/community/ThreadItem.js
import React from 'react';
import ThreadTags from './ThreadTags';

const ThreadItem = ({ thread, onClick }) => {
  // Format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Format thread preview (first 150 characters of content)
  const getThreadPreview = (content) => {
    if (!content) return '';
    if (content.length <= 150) return content;
    return content.substring(0, 150) + '...';
  };

  // Check if thread has associated media
  const hasAssociatedMedia = thread.associatedMediaType && thread.associatedMediaId;

  return (
    <div className="thread-item" onClick={() => onClick && onClick(thread)}>
      <div className="thread-item-header">
        <div className="thread-item-user">
          <img 
            src={thread.userId.profilePicture || "/default-avatar.png"} 
            alt={thread.userId.username} 
            className="thread-user-avatar"
          />
          <span className="thread-username">{thread.userId.username}</span>
        </div>
        <div className="thread-item-meta">
          <span className="thread-date">{formatDate(thread.createdAt)}</span>
          <span className="thread-category">{thread.category}</span>
        </div>
      </div>
      
      {/* Associated Media (if present) */}
      {hasAssociatedMedia && (
        <div className="thread-associated-media">
          <div className="thread-media-badge" style={{ background: `var(--${thread.associatedMediaType}-accent-primary)` }}>
            {thread.associatedMediaType === 'anime' ? 'Anime' : 'Manga'}
          </div>
          <div className="thread-media-content">
            {thread.associatedMediaImage && (
              <img 
                src={thread.associatedMediaImage} 
                alt={thread.associatedMediaTitle} 
                className="thread-media-image"
              />
            )}
            <span className="thread-media-title">{thread.associatedMediaTitle}</span>
          </div>
        </div>
      )}
      
      <h3 className="thread-item-title">{thread.title}</h3>
      
      {thread.content && (
        <div className="thread-item-preview">
          {getThreadPreview(thread.content)}
        </div>
      )}
      
      {thread.tags && thread.tags.length > 0 && (
        <ThreadTags 
          tags={thread.tags} 
          size="small"
          // No onClick handler for tags to avoid errors
        />
      )}
      
      <div className="thread-item-footer">
        <div className="thread-stats">
          <span className="thread-comments">
            <i className="icon-comment"></i> {thread.commentCount || 0} comments
          </span>
          <span className="thread-views">
            <i className="icon-eye"></i> {thread.views} views
          </span>
        </div>
        {thread.isPinned && <div className="thread-pinned">Pinned</div>}
      </div>
    </div>
  );
};

export default ThreadItem;